module.exports = __webpack_public_path__ + "img/glass-blur-top.4c8b7965.png";